import Modal from 'react-modal';
import styles from './ZoomOverlay.module.scss';
import { CloseIcon } from '../../assets/icons';
import { useTranslation } from '../../i18n/useTranslation';
import { Offscreen } from './Offscreen';

interface ZoomOverlayProps {
  open: boolean,
  setOpen: (open: boolean) => void,
  children: React.ReactNode,
}

export function ZoomOverlay(props: ZoomOverlayProps) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={props.open}
      onRequestClose={ () => props.setOpen(false) }
      contentLabel={ t('general_zoom_dialog_title') }
      overlayClassName={ styles.modal }
      className={ styles.modalContent }
    >
      <header className={ styles.headerBlock }>
        <button onClick={ () => props.setOpen(false) } className={ styles.closeButton }>
          <Offscreen>
            { t('general_zoom_dialog_close') }
          </Offscreen>
          <CloseIcon />
        </button>
      </header>
      <div className={ styles.contentBlock }>
        <div className={ styles.imageHolder }>
          { props.children }
        </div>
      </div>
    </Modal>
  );
}
